// extracted by mini-css-extract-plugin
export default {"wrapper":"Ko-z","response":"Lo-z","error":"Mo-z","disabled":"No-z","buttons":"Oo-z","feedbackQuestionSection":"Po-z","yesNoWrapper":"Qo-z"};